import LinkSerializer from './LinkSerializer';

const defaultSerializers = {
  marks: {
    link: LinkSerializer,
  },
};

export { defaultSerializers };
